import wait from "./wait"

const requestBatch = async (setProgress, parametersList, operationRequest) => {
  let operationCount = 1
  const totalRequestsCount = parametersList.length + 1

  const result = []

  for (const { parameters } of parametersList) {
    const { data } = await operationRequest(parameters)
    result.push(data)

    setProgress(Math.ceil(operationCount * 100 / totalRequestsCount))
    operationCount++

    await wait(true)
  }

  return result
}

export default requestBatch
